import ContentApiSerializer from 'rise-ui/serializers/apis/rise-api/content.js';

import { keyForAttribute } from 'rise-ui/utils/serializer/map.js';

const bodyAttributes = {
  bodyFormat: 'format',
  bodyProcessed: 'processed',
  bodySummary: 'summary',
  bodyValue: 'value',
};
const bodyAttributeKeys = Object.keys(bodyAttributes);

/**
 * Base serializer for ember-data requests to data-admin server for node content
 */
@keyForAttribute({
  createdDate: 'created',
})
export default class NodeContentApiSerializer extends ContentApiSerializer {
  extractAttributes(modelClass, resourceHash) {
    const attrs = super.extractAttributes(...arguments);
    const body = resourceHash.attributes?.body;
    if (body) {
      Object.entries(bodyAttributes).forEach(([ toKey, fromKey ]) => {
        attrs[toKey] = body[fromKey];
      });
    }
    return attrs;
  }

  serializeAttribute(snapshot, json, key, attributes) {
    const attr = json.attributes = json.attributes || {};
    if (key === 'uuid') {
      attr.uuid = snapshot.id;
      return;
    } else if (bodyAttributeKeys.includes(key)) {
      const body = attr.body = attr.body || {};
      body[bodyAttributes[key]] = snapshot.attr(key);
      return;
    }
    super.serializeAttribute(snapshot, json, key, attributes);
  }
}
